import React from 'react';
import PropTypes from 'prop-types';
import { I18nText, Pagination } from '@welldev-group/react-comp-lib';

const PaginationWithTranslation = props => {
  const { currentPage, totalPages, onPaginationClick } = props;

  return (
    <Pagination
      firstText={<I18nText id="pagination.first" />}
      lastText={<I18nText id="pagination.last" />}
      nextText={<I18nText id="pagination.next" />}
      previousText={<I18nText id="pagination.previous" />}
      currentPage={currentPage}
      totalPages={totalPages}
      onPaginationClick={onPaginationClick}
    />
  );
};

PaginationWithTranslation.defaultProps = {
  totalPages: 1,
};

PaginationWithTranslation.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number,
  onPaginationClick: PropTypes.func.isRequired,
};

export default PaginationWithTranslation;
